export const TokenExpirationCookie = "token_expiration"
export const UserSession = "user_session"